<template>
	<div>
		<!-- Crear notificacion nueva -->
		<pui-modal-dialog-form
			:overflow="false"
			:titleText="$t('notificationVisitor.sendNewNotification')"
			:modelName="modelName"
			:dialogName="dialogNameCreateNewNotification"
			v-model="modalData"
			:widthDialog="800"
			:onOk="onOkCreateNewNotification"
			:showDialogProp="getShowDialogCreateNewNotification"
		>
			<template slot="message">
				<v-layout wrap>
					<v-flex md6 xl6 xs6>
						<pui-select
							:label="$t('notificationVisitorModal.notiexhibitor')"
							required
							toplabel
							clearable
							disabled
							modelName="exhibitor"
							v-model="modalData"
							:itemsToSelect="[{ exhiid: modalData.exhiid }]"
							:modelFormMapping="{ exhiid: 'exhiid' }"
							itemValue="exhiid"
							itemText="exhiname"
							:key="'exhiname_' + myKey"
						></pui-select>
					</v-flex>
				</v-layout>
				<v-layout wrap>
					<v-flex xs12 lg12 md12>
						<pui-text-field
							v-model="modalData.intevisitorid"
							:label="$t('notificationVisitorModal.notidestvisitor')"
							maxlength="100"
							disabled
							toplabel
							required
						></pui-text-field>
					</v-flex>
				</v-layout>
				<v-layout wrap>
					<v-flex xs12 lg12 md12>
						<pui-text-field
							v-model="modalData.notititle"
							:label="$t('notificationVisitorModal.notititle')"
							maxlength="200"
							toplabel
							required
						></pui-text-field>
					</v-flex>
				</v-layout>
				<v-layout wrap>
					<v-flex xs12 lg12 md12>
						<pui-text-area
							v-model="modalData.noticontent"
							:label="$t('notificationVisitorModal.noticontent')"
							maxlength="1000"
							toplabel
							required
						></pui-text-area>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	name: 'interestexhibitorproductmodals',
	data() {
		return {
			model: 'interestexhibitorproduct',
			modalData: {},
			myKey: 0,
			dialogNameCreateNewNotification: 'sendToVisitor',
			showDialogCreateNewNotification: true
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	created() {
		this.$puiEvents.$on(`pui-modalDialogForm-${this.dialogNameCreateNewNotification}-${this.modelName}-show`, () => {
			this.showDialogCreateNewNotification = true;
		});
	},
	computed: {
		getShowDialogCreateNewNotification() {
			return this.showDialogCreateNewNotification;
		}
	},
	methods: {
		onOkCreateNewNotification(modalData) {
			const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$t('notificationVisitor.sendNewNotification');
			const urlController = '/notification/sendToVisitor';
			const body = {
				title: modalData.notititle,
				content: modalData.noticontent,
				exhibitorId: modalData.exhiid,
				visitor: modalData.intevisitorid
			};

			this.$puiRequests.postRequest(
				urlController,
				body,
				() => {
					this.$puiEvents.$emit('onPui-action-running-ended-' + this.model);
					const message = this.$puiI18n.t('puiaction.notifySuccess');
					this.$puiNotify.success(message, title);
					this.showDialogCreateNewNotification = false;
				},
				e => {
					let message = '';
					if (e.response.data.internalCode === 211) {
						message = this.$puiI18n.t('notiaction.usernotfound');
					} else {
						message = this.$puiI18n.t('puiaction.notifyError');
					}

					this.$puiNotify.error(message, title);
				}
			);
		}
	}
};
</script>

<style lang="postcss" scoped></style>
